declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, TreatmentCyclesController, TreatmentCyclesRequest, IvfWorkbenchController, IvfWorkbenchRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
//import { NgbAddNewPatient } from './modal/addnewpatient.modal';





@Component({
  selector: 'ivfworkbench',
  templateUrl: './ivfworkbench.component.html',
  styleUrls: [
    './ivfworkbench.component.scss']
  , animations: [routerTransition()]
})

export class IVFWorkBenchComponent implements OnInit {


  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
  public Testversion: boolean = true;
  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public Showrow: boolean = true;
  public ShowPatientDetails: boolean = false;
  public Showivfbench: boolean = true;
  public ScanDetails: boolean = false;
  public PickUpDetails: boolean = false;
  public ETDetails: boolean = false;
  public SADetails: boolean = false;
  public InseminationDetails: boolean = false;
  public OQADetails: boolean = false;
  public GradingDetails: boolean = false;
    public FreezingDetails: boolean = false;
    public SelectedDatenew: Date;
    public SelectedFromDate: NgbDateStruct;
    TodayDate = new Date();
  public isRequesting: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;
    HasAccess2(featureName: string): boolean {

    /*return*/ false;
        //////  alert(featureName);
        var f = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.filter(function (v, i, d) {
            return v.FeatureName == featureName && AppData.Instance().SelectedRoleName == v.RoleName;
        });
        //if (featureName == 'Patients List') {

        //    alert(f.length);
        //}
        //alert(f.length);
        return f != null && f.length > 0;
    }
  CurrentIvfworkbenchController: IvfWorkbenchController;
  CurrentIvfworkbenchRequest: IvfWorkbenchRequest;
  LoadIvf() {
    this.CurrentIvfworkbenchRequest = new IvfWorkbenchRequest;
    this.CurrentIvfworkbenchRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfWorkbenchController();
  }
  GetIvfWorkbenchController() {
    this.StartRefreshing();
      this.SelectedDatenew = new Date(this.parserFormatter.format(this.SelectedFromDate));
      //this.ProviderAvlSlotsRequest.ToDate = new Date((this.SelectedDatenew).getTime() + (60 * 60 * 24 * 1000));
    this.CurrentIvfworkbenchRequest.FromDate = new Date();
      this.CurrentIvfworkbenchRequest.ToDate = new Date((new Date()).getTime() + (60 * 60 * 24 * 1000));
      this.CurrentIvfworkbenchRequest.SearchText = "";
      this.CurrentIvfworkbenchRequest.Branch = AppData.Instance().SelectedBranchCode.toString();

    //this.CurrentFDActorDocRequest.ActorReportCode = null;
    //this.CurrentFDActorDocRequest.ActorReportTemplateCode = null;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfWorkbenchController(this.CurrentIvfworkbenchRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfworkbenchController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadPatients();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
      private route: ActivatedRoute,
      private parserFormatter: NgbDateParserFormatter,
    private loginservice: LoginService) { }

  ngOnInit() {
      this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

    //this.GetPatientInfoByFormattedCodeController();
      this.LoadIvf();

  }



  ShowList: boolean = true;



  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
  display(l: IvfWorkbenchController) {
    if (l.Name == "Scans") {
      this.router.navigate(['healins/ivfscans']);
    }

    else if (l.Name == "PickUps") {
      this.router.navigate(['healins/ivfpickups']);
    }
    else if (l.Name == "Ready for Pickup") {
      this.router.navigate(['healins/ivfpickupsready']);
    }
    else if (l.Name == "Oocyte Quality Assessment") {
      this.router.navigate(['healins/ivfoqa']);
    }
    else if (l.Name == "Insemination") {
      this.router.navigate(['healins/ivfinsemination']);
    }
    else if (l.Name == "EmbryoGrading") {
      this.router.navigate(['healins/ivfembryograding']);
    }
    else if (l.Name == "ReadyForTransfer") {
      this.router.navigate(['healins/ivffreezing']);
    }
    else if (l.Name == "FET Grading") {

    }
    else if (l.Name == "Calander") {

    }
    else if (l.Name == "") {

    }
  }
  displaydashboard() {
    this.router.navigate(['healins/newdashboard']);
  }
  displayscans() {
    //this.Showivfbench = false;
    //this.ScanDetails = true;
    this.router.navigate(['healins/ivfscans']);
  }
  displaypickup() {
    //this.Showivfbench = false;
    //this.PickUpDetails = true;
    this.router.navigate(['healins/ivfpickups']);
  }
  displaypickupready() {
    this.router.navigate(['healins/ivfpickupsready']);

  }
  displayet() {
    //this.Showivfbench = false;
    //this.ETDetails = true;
    this.router.navigate(['healins/ivfembryotransfer']);
  }
    displaycp() {
        this.router.navigate(['healins/cryopre']);
    }
    displayCounselling() {
        this.router.navigate(['healins/counsellingregister']);
    }
    displayActivity() {
      this.router.navigate(['healins/dailyworkbook']);
    }
    displaypt() {
    //this.Showivfbench = false;
    //this.ETDetails = true;
    this.router.navigate(['healins/ivfpregnancytracker']);
  }
  displaysa() {
    //this.Showivfbench = false;
    //this.SADetails = true;
    this.router.navigate(['healins/ivfsemen']);
  }
  displayinsemination() {
    //this.Showivfbench = false;
    //this.InseminationDetails = true;
    this.router.navigate(['healins/ivfinsemination']);
  }
  displayoqa() {
    //this.Showivfbench = false;
    //this.OQADetails = true;
    this.router.navigate(['healins/ivfoqa']);
  }
  displaygrading() {
    //this.Showivfbench = false;
    //this.GradingDetails = true;
    this.router.navigate(['healins/ivfembryograding']);
  }
  displayfreezing() {
    //this.Showivfbench = false;
    //this.FreezingDetails = true;
    this.router.navigate(['healins/ivffreezing']);
  }
  //AddNewPatient() {

  //  const modalRef = this.modalService.open(NgbAddNewPatient,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;
  //  //modalRef.componentInstance.ActorCode = this.ActorCode;
  //  modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  //}
  CancelNewOperation() {

    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }

  //SelectedPatient: PatientInfoByFormattedCodeController;
  //ViewPatientDetails(objCategory: any) {
  //  var patient: PatientInfoByFormattedCodeController = objCategory;

  //  if (patient != null) {



  //    this.ShowPatientDetails = true;
  //    this.ShowList = false;
  //    this.SelectedPatient = patient;
  //    this.Showarrow = true;
  //    this.Showrow = false;
  //    //this.LoadPatientdetails()

  //  }
  //  else {
  //    this.ShowPatientDetails = false;
  //  }
  //}
  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {


  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();

  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}
  SelectedPatient: TreatmentCyclesController;
  ViewPatientDetails(objCategory: any) {
    var patient: TreatmentCyclesController = objCategory;
    if (patient != null) {
      this.SelectedPatient = null;
      this.SelectedPatient = patient;
      this.ShowList = false;
      this.ShowPatientDetails = true;
      this.Showarrow = false;
      this.Showrow = false;
      //this.ShowData = false;

    }
    else {

    }

  }




}
